<template>
  <div class="swiper-container">
    <!-- Swiper -->
    <div class="swiper mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">Slide 1</div>
        <div class="swiper-slide">Slide 2</div>
        <div class="swiper-slide">Slide 3</div>
        <div class="swiper-slide">Slide 4</div>
        <div class="swiper-slide">Slide 5</div>
        <div class="swiper-slide">Slide 6</div>
        <div class="swiper-slide">Slide 7</div>
        <div class="swiper-slide">Slide 8</div>
        <div class="swiper-slide">Slide 9</div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
// import Swiper from "swiper/dist/js/swiper.min.js";
// import "swiper/dist/css/swiper.min.css";
// import 'assets/js/swiper-bundle.min'
export default {
  mounted() {
     var swiper = new Swiper(".mySwiper", {
        slidesPerView: 4,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
  },
};
</script>

<style>
/* @import url(../assets/js/swiper-bundle.min.css); */
 .swiper {
        width: 100%;
        height: 100%;
      }

      .swiper-slide {
      
        /* background: pink; */
       
      }

      
</style>
